import { GendersDatasource } from "@beneficiary/data/datasource/genders.datasource";
import { Gender } from "@beneficiary/domain/models/gender.model";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class GendersRepository {
    constructor(
        @inject(GendersDatasource)
        private readonly genderDatasource: GendersDatasource,
    ) {}

    async getAll(): Promise<Either<FallbackError, Gender[]>> {
        return this.genderDatasource.fetchAllGenders();
    }
}
